import React from "react";
import { PathDetails } from "@/res/data/Paths";
import { Countries } from "@/res/data/Countries";
import { Trans, useTranslation } from "react-i18next";
import ContentWrapper from "@/res/components/ClientCreate/content-wrapper";
import CompleteFormIcon from "@/assets/icons/funnel-complete-form-icon.svg";
import ChooseServiceIcon from "@/assets/icons/funnel-choose-service-icon.svg";
import SignContractIcon from "@/assets/icons/funnel-sign-contract-icon.svg";

const ContentDefault = (props) => {
    const [t] = useTranslation();

    return (
        <ContentWrapper title={ PathDetails(props?.country, props?.service)?.label_english + " " + Countries[props?.country]?.country_details?.name_english } {...props}>
            <h2>
                {t("pages.start.header")}
            </h2>
            <p>
                <Trans i18nKey="pages.start.description">
                    <span className="show-desktop"/>
                    <span className="hide-desktop"/>
                </Trans>
            </p>
            <div style={{ margin: "4.5rem 0 0" }} className="show-tablet-and-down"/> {/*TODO*/}
            <div className="how-it-works">
                <div>
                    <img src={CompleteFormIcon} alt=""/>
                    <p>
                        1. {t("pages.start.steps.1")}
                    </p>
                </div>
                <div>
                    <img src={ChooseServiceIcon} alt=""/>
                    <p>
                        2. {t("pages.start.steps.2")}
                    </p>
                </div>
                <div>
                    <img src={SignContractIcon} alt=""/>
                    <p>
                        3. {t("pages.start.steps.3")}
                    </p>
                </div>
            </div>
        </ContentWrapper>
    );
};

export default ContentDefault;
